var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithoutPermanence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 133,
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .637h132.362V133H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "o",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "q",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "u",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "w",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "y",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "A",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "C",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "K",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M.723 1.951l3.571 73.732 19.653-.953.547-16.652 4.165-7.611-3.754-4.833 4.276-10.997-3.621-8.905 3.536-8.337L26.384.709z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Q",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "U",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "W",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Y",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aa",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ac",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ae",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ag",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ai",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ak",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "am",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ao",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aq",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "as",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "au",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aw",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ay",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aA",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aC",
    d: "M9.765 25.634L4.048 35.892l3.28 8.357-6.536 9.837 4.502 5.712-4.566 8.149 1.876 12.407 26.763 1.539 4.625-80.434-20.907-1.2z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -.637)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M132.362 66.818c0 36.55-29.63 66.182-66.181 66.182S0 103.369 0 66.818 29.63.637 66.18.637c36.552 0 66.182 29.63 66.182 66.18",
    fill: "#3A913F",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58.803 102.467l-1.104-1.551 6.182-4.396-8.466-3.153 7.658-4.185-4.29-4.021 7.632-7.151-3.82-5.885 6.445-10.007-3.152-8.621 5.87-9.699-8.142-8.279 6.374-6.961 1.403 1.285-5.154 5.629 7.913 8.046-6.163 10.183 3.165 8.653-6.292 9.767 4.017 6.189-7.312 6.851 4.725 4.43-6.306 3.447 7.924 2.951z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(32 23.363)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    mask: "url(#d)",
    d: "M35.411 64.164L11.514 65.32 8.811 9.545l23.9-1.157z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#f)",
    d: "M29.858 17.358l-17.771.86-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#h)",
    d: "M30.17 19.384l-17.77.86-.027-.543 17.771-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#j)",
    d: "M30.269 21.42l-17.771.861-.025-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#l)",
    d: "M30.368 23.457l-17.77.86-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#m"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#n)",
    d: "M30.466 25.494l-17.77.86-.026-.542 17.77-.861z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#o"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#p)",
    d: "M30.565 27.53l-17.77.86-.026-.542 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "r",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#r)",
    d: "M30.45 29.578l-17.771.86-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "t",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#t)",
    d: "M30.762 31.604l-17.77.86-.026-.543 17.771-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "v",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#u"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#v)",
    d: "M30.861 33.64l-17.77.861-.026-.543 17.771-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "x",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#w"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#x)",
    d: "M30.96 35.677l-17.771.86-.025-.543 17.771-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#z)",
    d: "M31.06 37.713l-17.771.861-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#B)",
    d: "M31.158 39.75l-17.771.86-.026-.542 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "D",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#C"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#D)",
    d: "M31.041 41.797l-17.77.861-.027-.544 17.772-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "F",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#E"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#F)",
    d: "M31.355 43.824l-17.77.86-.027-.543 17.772-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "H",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#G"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#H)",
    d: "M31.454 45.86l-17.771.86-.026-.542 17.77-.861z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "J",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#I"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#J)",
    d: "M31.553 47.897l-17.771.86-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#K"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#L)",
    d: "M31.651 49.934l-17.77.86-.027-.543 17.771-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "N",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#M"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#N)",
    d: "M31.75 51.97l-17.771.86-.026-.543 17.77-.86z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "P",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#O"
  })), /*#__PURE__*/React.createElement("text", {
    mask: "url(#P)",
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 5.513,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 30.032,
    y: 58.007
  }, "x"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70 17.363)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "R",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Q"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    mask: "url(#R)",
    d: "M20.722 74.279L-2.565 72.94.64 17.19l23.287 1.339z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "T",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#S"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#T)",
    d: "M20.225 27.154L2.91 26.158l.031-.542 17.315.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "V",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#U"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#V)",
    d: "M20.317 29.2l-17.315-.994.031-.543 17.315.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "X",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#W"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#X)",
    d: "M20.2 31.237l-17.315-.995.03-.543 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "Z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#Y"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#Z)",
    d: "M20.084 33.273l-17.316-.996.031-.543 17.316.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ab",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aa"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ab)",
    d: "M19.966 35.308L2.65 34.313l.031-.543 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ad)",
    d: "M19.85 37.344l-17.315-.996.03-.543 17.316.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "af",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ae"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#af)",
    d: "M19.523 39.368l-17.315-.996.031-.542 17.315.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ah",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ag"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ah)",
    d: "M19.615 41.416L2.3 40.42l.031-.544 17.315.997z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "aj",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ai"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#aj)",
    d: "M19.498 43.45l-17.315-.994.031-.543 17.315.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "al",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ak"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#al)",
    d: "M19.382 45.487L2.066 44.49l.03-.543 17.317.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "an",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#am"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#an)",
    d: "M19.265 47.522L1.95 46.527l.03-.543 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ap",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ao"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ap)",
    d: "M19.148 49.558l-17.316-.996.031-.543 17.316.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ar",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aq"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ar)",
    d: "M18.82 51.581l-17.314-.995.03-.542 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "at",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#as"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#at)",
    d: "M18.913 53.63l-17.315-.997.03-.543 17.316.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "av",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#au"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#av)",
    d: "M18.797 55.665L1.48 54.67l.03-.543 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "ax",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aw"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#ax)",
    d: "M18.68 57.7l-17.317-.995.031-.543 17.316.996z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "az",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ay"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#az)",
    d: "M18.562 59.736L1.247 58.74l.03-.543 17.316.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "aB",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aA"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#aB)",
    d: "M18.445 61.772L1.13 60.776l.031-.542 17.315.995z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "aD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#aC"
  })), /*#__PURE__*/React.createElement("text", {
    mask: "url(#aD)",
    fontFamily: "LucidaGrande, Lucida Grande",
    fontSize: 4.878,
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.019,
    y: 68.27
  }, "x"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutPermanence);
export default __webpack_public_path__ + "static/media/without-permanence.4f968e0f1c141c0357e9ab0d062fa7b7.svg";
export { ForwardRef as ReactComponent };